var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraining(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 136 136",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard2",
    x: 0,
    y: 0,
    width: 135.583,
    height: 135.583,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.086,26.429c-0.612,-0.348 -1.353,-0.385 -1.997,-0.1c-6.14,2.716 -38.18,16.886 -48.813,21.588c-0.718,0.318 -1.216,0.991 -1.309,1.771c-0.093,0.78 0.233,1.551 0.857,2.029c8.652,6.623 33.519,25.655 39.22,30.019c0.712,0.545 1.681,0.609 2.458,0.164c6.868,-3.938 39.369,-22.571 50.011,-28.672c0.693,-0.397 1.12,-1.136 1.118,-1.934c-0.002,-0.799 -0.432,-1.535 -1.126,-1.93c-9.338,-5.298 -35.088,-19.91 -40.419,-22.935Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.523,94.717l-0,-24.576c-0,-0 18.226,13.94 23.084,17.655c0.714,0.546 1.685,0.609 2.463,0.16c6.398,-3.692 34.521,-19.92 34.521,-19.92l-0,26.59l-60.068,0.091c-0,-0 60.068,-0.091 60.068,-0.091c-5.213,8.932 -18.962,14.817 -30.034,14.817c-11.11,0 -24.862,-5.742 -30.034,-14.726Zm-0,-0c-0,-0 -1.939,-3.304 -0,-0l-0,-0Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.136,84.425l0.21,-32.646l-3.91,3.178l-0,29.468l3.7,-0Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.391,73.757c-0,0 -5.554,11.047 -5.554,15.781c-0,3.065 2.489,5.554 5.554,5.554c3.065,-0 5.554,-2.489 5.554,-5.554c0,-4.734 -5.554,-15.781 -5.554,-15.781Z",
    style: {
      fill: "currentColor"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.ae590462.svg";
export { ForwardRef as ReactComponent };